/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_RestoringInputs */



/**
* | output |
* | --- |
* | "Restoring checkpoint…" |
*
* @param {Assistant_RestoringInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restoring = /** @type {((inputs?: Assistant_RestoringInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_RestoringInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restauration du point de contrôle…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellung des Kontrollpunkts…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristino del checkpoint…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановление контрольно-пропускного пункта…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurando el punto de control…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在恢复检查点……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チェックポイントを復元しています…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चेकपॉइंट बहाल किया जा रहा है…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurando o ponto de controle…")
	return /** @type {LocalizedString} */ ("Restoring checkpoint…")
});